import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CollectionStatementsComponent } from './collection-statements/collection-statements.component';
import { CommunityGuidelinesComponent } from './community-guidelines/community-guidelines.component';
import { CustomerTermsComponent } from './customer-terms/customer-terms.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ProviderTermsComponent } from './provider-terms/provider-terms.component';
import { SiteMapComponent } from './sitemap/sitemap.component';

@NgModule({
  declarations: [
    PrivacyPolicyComponent,
    CommunityGuidelinesComponent,
    CustomerTermsComponent,
    ProviderTermsComponent,
    DisclaimerComponent,
    CollectionStatementsComponent,
    SiteMapComponent
  ],
  imports: [CommonModule, RouterModule]
})
export class TermsModule {}
